
import React from "react";
import { Editor } from "@tiptap/react";
import { Link as LinkIcon } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import LinkForm from "../LinkForm";

interface LinkToolProps {
  editor: Editor;
  linkPopoverOpen: boolean;
  setLinkPopoverOpen: (open: boolean) => void;
}

const LinkTool = ({ editor, linkPopoverOpen, setLinkPopoverOpen }: LinkToolProps) => {
  return (
    <Popover open={linkPopoverOpen} onOpenChange={setLinkPopoverOpen}>
      <PopoverTrigger asChild>
        <Button 
          type="button"
          variant={editor.isActive('link') ? "default" : "ghost"} 
          size="icon" 
          className={`h-8 w-8 ${editor.isActive('link') ? 'bg-secondary' : ''}`}
        >
          <LinkIcon className="h-4 w-4" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-80">
        <LinkForm editor={editor} onClose={() => setLinkPopoverOpen(false)} />
      </PopoverContent>
    </Popover>
  );
};

export default LinkTool;
